import { getErrorStatus } from '@/api/errors'
import type { VariableGroupTriggerOptions } from '@/types'

export function hasMissingRequiredGroup(options: VariableGroupTriggerOptions | undefined): boolean {
  return (options?.required ?? []).some(group => group.groupId === null)
}

export function isVariableGroupAccessDenied(error: unknown): boolean {
  return getErrorStatus(error) === 403
}

export function isVariableGroupSelectionBlocked(options: VariableGroupTriggerOptions | undefined, isLoading: boolean, error: unknown): boolean {
  return isLoading || (!!error && !isVariableGroupAccessDenied(error)) || hasMissingRequiredGroup(options)
}

export function selectableGroupIds(options: VariableGroupTriggerOptions | undefined, selectedIds: string[]): string[] {
  const offered = new Set((options?.optional ?? []).map(group => group.groupId))
  return selectedIds.filter(id => offered.has(id))
}
